module.exports = __webpack_public_path__ + "media/images/logo-d33180d27cf96d737ed517bdf0046901.svg";